module.exports = __webpack_public_path__ + "media/newstyle/images/100-mil-book-es-1c652125f09b9837a60e522b06866209.svg";